import React from "react";
import { Container } from "reactstrap";

const ErrorPage = props =>  {
  return (
    <Container>
      <div className='pad5 p-5 m-5 text-center center text-danger'>
        {props.msg || "Página não encontrada!"}
      </div>
    </Container>
  );
}

export default ErrorPage;
